import React from "react";
import {makeStyles, Box, Grid, Link, Typography, Button} from "@material-ui/core";
import {NavLink, useLocation} from "react-router-dom";

const useStyles = makeStyles(() => ({
    link: {
        border: "none",
        "&:hover": {
            textDecoration: "none"
        }
    },
    buttons: {
        width: "250px",
        height: "48px",
        marginBottom: 10,
        marginRight: 10,
    }
}));

const AppointmentsReviewNavigation = () => {
    const classes = useStyles();
    const { state: { appointmentId } } = useLocation<{ appointmentId: number }>();
    const { pathname } = useLocation<{ pathname: string }>();
    const reviewBtnColor = pathname === "/apointmentRate" ? "secondary" : "default";
    const notesBtnColor = pathname === "/apointmentNotes" ? "secondary" : "default";
    return (
        <Box marginBottom="20px">
            <Grid container>
                <Link component={NavLink} className={classes.link} exact to={{pathname:"/apointmentRate",state: {appointmentId: appointmentId}}}>
                    <Button type="button" variant="contained" color={reviewBtnColor} className={classes.buttons}>Review</Button>
                </Link>
                <Link component={NavLink} className={classes.link} exact to={{pathname:"/apointmentNotes",state: {appointmentId: appointmentId, afterAppt: true}}}>
                    <Button type="button" variant="contained" color={notesBtnColor} className={classes.buttons}>Notes</Button>
                </Link> 
            </Grid>
        </Box>
    );
};

export default AppointmentsReviewNavigation;
